<div class="db-migrate-for-booster">
  <db-migration-only-dialog
    [hasBackButton]="false"
    [currentSubscription]="currentSubscription">
  </db-migration-only-dialog>
</div>
